"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CustomerCardReducer = exports.CustomerCardClearData = exports.CustomerCardClearData_success = exports.CUSTOMER_CARD_CLEAR_DATA_SUCCESS = undefined;

var _nodeToolbox = require("@esnpm/node-toolbox");

var _apiCustomerCard = require("../actions/esdb/apiCustomerCard");

var _lodash = require("lodash");

var _ = _interopRequireWildcard(_lodash);

var _apiCustomerCardByEmail = require("../actions/esdb/apiCustomerCardByEmail");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// setzt data von aktuell geladener CustomerCard auf null
var CUSTOMER_CARD_CLEAR_DATA_SUCCESS = exports.CUSTOMER_CARD_CLEAR_DATA_SUCCESS = "CUSTOMER_CARD_CLEAR_DATA_SUCCESS";
var CustomerCardClearData_success = exports.CustomerCardClearData_success = function CustomerCardClearData_success(options) {
	return {
		type: CUSTOMER_CARD_CLEAR_DATA_SUCCESS
	};
};
var CustomerCardClearData = exports.CustomerCardClearData = function CustomerCardClearData(options) {
	return function (dispatch, getState) {
		return new Promise(function (resolve, reject) {
			try {
				dispatch(CustomerCardClearData_success(options));
				resolve();
			} catch (e) {
				reject(e);
			}
		});
	};
};

var CustomerCardReducer = exports.CustomerCardReducer = function CustomerCardReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];


	var newState = void 0;

	switch (action.type) {

		case _apiCustomerCard.API_CUSTOMER_CARD_REQUEST:
			return _.merge({}, state, _defineProperty({}, action.options.HASH, action.payload));

		case _apiCustomerCardByEmail.API_CUSTOMER_CARD_BY_EMAIL_SUCCESS:
		case _apiCustomerCard.API_CUSTOMER_CARD_SUCCESS:
			return _.assign({}, state, _defineProperty({}, action.payload.data.HASH, action.payload));

		default:
			return state;
	}
};